import { Injectable } from '@angular/core';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { CrudService } from '../crudService';
import { BaseEntityStoreStrategy } from '../updateStoreStrategies';
import { KeyvalueQuery } from './keyvalue.query';
import { KeyvalueStore } from './keyvalue.store';
import { IKeyvalue } from '@common/interfaces/keyvalue';

@Injectable({
  providedIn: 'root'
})
export class KeyvalueService extends CrudService<IKeyvalue, KeyvalueStore, KeyvalueQuery> {

  constructor(
    protected store: KeyvalueStore,
    public query: KeyvalueQuery,
    protected actionService: ActionService,
    protected updateStrategy: BaseEntityStoreStrategy,
  ) {
    super(
      Topics.KEYVALUES,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

}
